let globalToast = null

export function registerGlobalToast(toast) {
  globalToast = toast
}

export function showGlobalToast(type, message, callback) {
  const showToast = globalToast && globalToast[type]

  if (typeof showToast === 'function') {
    showToast.call(globalToast, message, callback)
    return
  }

  if (callback) {
    callback()
  }
}
